// extracted by mini-css-extract-plugin
export var acitonButtons = "_ht-0";
export var additionalIcon = "_ht-f";
export var block = "_ht-1";
export var blockContent = "_ht-7";
export var blockDescription = "_ht-8";
export var blockIcon = "_ht-9";
export var blockTitle = "_ht-6";
export var border = "_ht-a";
export var center = "_ht-l";
export var edge = "_ht-b";
export var edgeLabel = "_ht-c";
export var edgePath = "_ht-d";
export var error = "_ht-e";
export var flowchart = "_ht-g";
export var flowchartContent = "_ht-h";
export var highlighted = "_ht-3";
export var hover = "_ht-4";
export var icon = "_ht-i";
export var left = "_ht-m";
export var navButton = "_ht-j";
export var navButtons = "_ht-k";
export var right = "_ht-n";
export var selected = "_ht-2";
export var small = "_ht-5";